import { render, staticRenderFns } from "./FeedbackManuscriptModeSelectionDialog.vue?vue&type=template&id=29991ebb&scoped=true"
import script from "./FeedbackManuscriptModeSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./FeedbackManuscriptModeSelectionDialog.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackManuscriptModeSelectionDialog.vue?vue&type=style&index=0&id=29991ebb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29991ebb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29991ebb')) {
      api.createRecord('29991ebb', component.options)
    } else {
      api.reload('29991ebb', component.options)
    }
    module.hot.accept("./FeedbackManuscriptModeSelectionDialog.vue?vue&type=template&id=29991ebb&scoped=true", function () {
      api.rerender('29991ebb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/FeedbackManuscriptModeSelectionDialog.vue"
export default component.exports